export default __webpack_public_path__ + "static/media/mamut_m3.234806a2.png";